import { FormComponent, element as $, elements as $$ } from '@contorion/core';

const CLASS_HIDDEN: string = 'hidden';
const VALUE_B2B: string = 'B2B';
const SELECTOR_COMPANY_TYPE_INPUT: string = 'input[name="registration[type]"]';
const SELECTOR_CHECKED: string = ':checked';
const SELECTOR_COMPANY_FIELD: string = '.js-company';
const SELECTOR_COMPANY_INPUT: string = '#registration_company';
const SELECTOR_EMPLOYEES_INPUT: string = '#registration_employees';
const ATTRIBUTE_NAME_DI_FIELD_ID: string = 'data-di-field-id';
const ATTRIBUTE_PRIVATE: string = 'registerprivate';
const ATTRIBUTE_BUSINESS: string = 'registerbusiness';

export class RegisterFormComponent extends FormComponent {
    protected get companyFields(): Array<HTMLElement> {
        return $$<HTMLElement>(SELECTOR_COMPANY_FIELD, this.element);
    }

    protected get companyInput(): HTMLInputElement {
        return <HTMLInputElement> $(SELECTOR_COMPANY_INPUT, this.element);
    }

    protected get employeesInput(): HTMLSelectElement {
        return <HTMLSelectElement> $(SELECTOR_EMPLOYEES_INPUT, this.element);
    }

    protected get customerTypeRadioButtons(): Array<HTMLInputElement> {
        return $$<HTMLInputElement>(SELECTOR_COMPANY_TYPE_INPUT, this.element);
    }

    protected get customerTypeRadioButtonChecked(): HTMLInputElement {
        return <HTMLInputElement> $(SELECTOR_COMPANY_TYPE_INPUT + SELECTOR_CHECKED, this.element);
    }

    protected get isB2bSelected(): boolean {
        return this.customerTypeRadioButtonChecked.value === VALUE_B2B;
    }

    constructor(protected element: HTMLFormElement) {
        super(element);

        this.element.addEventListener('change', this.onChange.bind(this));
        this.setTrackingAttributes();
        this.toggleCompanyFields();
    }

    protected setTrackingAttributes() {
        for (const element of this.customerTypeRadioButtons) {
            element.setAttribute(
                ATTRIBUTE_NAME_DI_FIELD_ID,
                element.value === VALUE_B2B ? ATTRIBUTE_BUSINESS : ATTRIBUTE_PRIVATE
            );
        }
    }

    protected toggleCompanyFields(): void {
        for (const companyField of this.companyFields) {
            if (this.isB2bSelected) {
                companyField.classList.remove(CLASS_HIDDEN);
            } else {
                companyField.classList.add(CLASS_HIDDEN);
            }
        }

        if (this.isB2bSelected) {
            this.companyInput.setAttribute('required', 'required');
            this.employeesInput.setAttribute('required', 'required');
        } else {
            this.companyInput.removeAttribute('required');
            this.employeesInput.removeAttribute('required');
        }
    }

    protected onChange(): void {
        this.toggleCompanyFields();
    }
}
